const initialState = {
  createAlertPending: false,
  createAlertError: null,
  createAlertsInProgress: [],
  createAlertsFailed: [],
  batchCreatePending: false,
  fetchAlertsPending: false,
  fetchAlertsError: null,
  alerts: false,
  removeAlertPending: false,
  removeAlertError: null,
  batchRemovePending: false,
  removeAlertsInProgress: [], // Array of alert IDs currently being removed
  removeAlertsFailed: [], // Array of alert IDs that failed to remove
  fetchInstancesPending: false,
  fetchInstancesError: null,
  fetchInstancesPagination: null,
  alertInstances: [],
  fetchIftttAlertsPending: false,
  fetchIftttAlertsError: null,
  iftttAlerts: false,
  fetchAlertSetsPending: false,
  fetchAlertSetsError: null,
  alertSets: false,
  createAlertSetPending: false,
  createAlertSetError: null,
  updateAlertSetPending: false,
  updateAlertSetError: null,
  removeAlertSetPending: false,
  removeAlertSetError: null,
};

export default initialState;
